// Articles / News store. Add new article objects here; pages update automatically.

export const SITE_URL = "https://puttraj.com";

export const ARTICLES = [
  {
    slug: "government-job-opportunities-karnataka-youth",
    title: "Government Job Opportunities for Karnataka Youth: Complete Career Guide 2026",
    seoTitle: "Government Job Opportunities for Karnataka Youth: Complete Career Guide 2026 | Puttraj",
    metaDescription:
      "Explore government job opportunities for Karnataka youth, competitive exams, preparation strategies, skill development, and career guidance from the Office of Puttraj.",
    focusKeyword: "Government Job Opportunities Karnataka Youth",
    author: "Office of Puttraj",
    category: "Career Guidance",
    tags: [
      "Government Jobs", "Karnataka", "KPSC", "UPSC", "SSC", "Banking Jobs",
      "Youth Development", "Career Guidance", "Employment", "Skill Development", "Puttraj",
    ],
    publishDate: "2026-01-10",
    publishDateDisplay: "10 January 2026",
    readMinutes: 8,
    image: "/photos/article-govt-jobs.svg",
    imageAlt: "Students preparing for Karnataka government competitive examinations.",
    excerpt:
      "A complete 2026 career guide for Karnataka's youth — government career paths, competitive exams, preparation strategy, and skill development from the Office of Puttraj.",
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
